"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _CategoryDropdown = _interopRequireDefault(require("@insided/shared/uikit/CategoryDropdown"));

var _utils = require("@insided/control/modules/ContentModeration/TopicModeration/utils");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CategorySelector = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategorySelector, _Component);

  var _super = _createSuper(CategorySelector);

  function CategorySelector() {
    var _this;

    (0, _classCallCheck2.default)(this, CategorySelector);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      categoryId: _this.props.categoryId
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectCategory", function (category) {
      var onSelectCategory = _this.props.onSelectCategory;
      onSelectCategory(category);

      _this.setState({
        categoryId: category.id
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategorySelector, [{
    key: "render",
    value: function render() {
      var _category$title;

      var categories = this.props.categories;
      var categoryId = this.state.categoryId;
      var category = (0, _utils.getCategory)(Object.values(categories).flat(), categoryId);
      var title = (_category$title = category === null || category === void 0 ? void 0 : category.title) !== null && _category$title !== void 0 ? _category$title : 'Select category';
      return (0, _preact.h)("div", {
        className: "form-group"
      }, (0, _preact.h)("label", null, "Category"), (0, _preact.h)(_inputUnit.default, null, (0, _preact.h)(_CategoryDropdown.default, {
        categories: categories,
        onSelectCategory: this.onSelectCategory,
        trigger: (0, _preact.h)(_Button.default, {
          title: title,
          endIcon: "chevronDown",
          size: "medium",
          fullWidth: true,
          "data-qa": "select-category"
        }),
        triggerClass: "dropdown-selector-wrapper--control"
      })));
    }
  }]);
  return CategorySelector;
}(_preact.Component);

var _default = CategorySelector;
exports.default = _default;